import { ReactComponent as YandexColorLight } from 'fym-shared/src/music-services/assets/images/yandex-color-light.svg';
import { ReactComponent as YandexColorDark } from 'fym-shared/src/music-services/assets/images/yandex-color-dark.svg';
import { ReactComponent as YandexColorLightPadding } from 'fym-shared/src/music-services/assets/images/yandex-color-light-padding.svg';
import { ReactComponent as YandexColorDarkPadding } from 'fym-shared/src/music-services/assets/images/yandex-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const yandexImages: MusicServiceImages = {
  logoColor: {
    light: YandexColorLight,
    dark: YandexColorDark,
  },
  logoColorPadding: {
    light: YandexColorLightPadding,
    dark: YandexColorDarkPadding,
  },
};
